module.exports = __webpack_public_path__ + "img/warning-1.6e95c0f1.png";